__webpack_require__.p = "/Music-Wordle-Game/";